import views from "../../assets/blog/views.svg";
import  defaultImg from "../../assets/blog/default.svg";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

export default function Card({title, image, description, tags, view, createdBy, date, id}) {
    const navigate = useNavigate();
    return(
        <>
            <article  onClick={()=> navigate(`/blogs/${id}`)} className="flex h-full cursor-pointer justify-center items-center min-w-[70%] sm:min-w-full p-[1.5px] rounded-xl hover:bg-gradient-to-r from-primary-color to-secondary-color bg-clip-border overflow-y-auto">
                <div className="w-full h-full bg-clip-border bg-white rounded-[0.75rem] border-[0.5px] border-[#999999] overflow-hidden">
                    <div className="w-full h-1/3">
                        {
                            !!image ? (
                                <div className="w-full min-h-full h-full">
                                    <img loading="lazy" src={image} alt="fleaturedimg" className="w-full min-h-full object-cover" />
                                </div>
                            ) : (
                                <div className="w-full min-h-full h-full">
                                    <img loading="lazy" src={defaultImg} alt="defaultimg" className="w-full h-full object-cover" />
                                </div>
                            )
                        }
                    </div>
                    <div className="w-full h-2/3 flex flex-col p-4 gap-2 justify-between bg-gradient-to-r from-[#FF99000D] to-[#04236B0D] ">
                        <p className="font-semibold text-[13 px] sm:text-lg md:text-xl line-clamp-2">
                            {title}
                        </p>
                        <p className="text-[#848383] text-[10px] sm:text-base line-clamp-2" dangerouslySetInnerHTML={{__html: description}}>
                        </p>
                        <div className="flex justify-between  text-[10px] sm:text-base">
                            <p className="text-primary-color">
                                {createdBy}
                            </p>
                            <p className="text-[#999999]">
                                {format(new Date(date), "dd/MM/yy")}
                            </p>
                        </div>
                        <div className="pt-4 w-full mt-1 text-[8px] sm:text-base flex justify-between items-center border-t-[0.5px] border-[#999999]">
                            <div className="flex w-fit flex-wrap gap-2 max-h-14 sm:max-h-10 overflow-y-clip">
                                {tags.map((tag)=>(
                                    <div key={tag} className="rounded-full text-center py-1 px-2 border-[0.5px] border-[#999999]">
                                        {tag}
                                </div>
                                ))}
                            </div>
                            <div className="flex w-fit items-center pr-1 text-[#999999] gap-1">
                                <img loading="lazy" src={views} alt="viewicon" className="w-4 h-4 sm:w-6 sm:h-6" />
                                <p>{view}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}